<template>
    <div v-if="featuredVideo">
        <div class="font-bold text-sm block text-2xl my-4">{{ featuredVideo.title }}</div>

        <AppVideo :type="featuredVideo.type" :clip="featuredVideo.video_id"></AppVideo>
    </div>

    <div class="grid gap-4 mt-4 grid-cols-1 md:grid-cols-2" v-if="regularVideos.length > 0"
         :class="{'xl:grid-cols-3': regularVideos.length >= 3}">
        <div v-for="video of regularVideos" class="flex flex-col">
            <div class="font-bold block text-2xl mb-auto">{{ video.title }}</div>

            <AppVideo :type="video.type" :clip="video.video_id" class="mt-4"></AppVideo>
        </div>
    </div>

    <SubscribeButton v-if="featuredVideo || regularVideos.length" class="mt-2"></SubscribeButton>
</template>

<script setup>
import {computed} from "vue";
import AppVideo from "@/Components/AppVideo";
import SubscribeButton from "@/Components/Videos/SubscribeButton";

const props = defineProps({
    videos: {
        type: Array,
        default: []
    }
});

const featuredVideo = computed(() => props.videos.find(video => video.featured));

const regularVideos = computed(() => props.videos.filter(video => !video.featured));
</script>

<style scoped>

</style>
